import { LegalLayout, LegalSection } from "./LegalLayout"

/**
 * DRAFT — pendente de revisão jurídica (CL-02). Rota canônica: /legal.
 * Conteúdo canônico em pt-br. NÃO publicar como final sem revisão jurídica.
 * Section headings: i18n keys (CL-04). Body prose remains pt-br until legal review.
 */
export const TermsPage = () => {
  return (
    <LegalLayout titleKey="legal.terms.title" lastUpdated="2026-05-19">
      <LegalSection headingKey="legal.terms.sections.acceptance">
        <p>
          Ao criar uma conta ou usar o Tessel, você concorda com estes Termos de
          Serviço e com a Política de Privacidade. Se não concordar, não use o
          serviço.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.serviceDescription">
        <p>
          O Tessel transforma sessões de RPG em uma base de conhecimento
          organizada por IA: transcrição, extração de eventos, resumos, busca e
          assistente. Recursos podem mudar ao longo do tempo.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.accounts">
        <p>
          Você é responsável por manter a segurança da sua conta e por toda
          atividade realizada nela. Informações de cadastro devem ser verídicas.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.acceptableUse">
        <p>
          É proibido enviar conteúdo ilegal, infringir direitos de terceiros,
          tentar burlar limites de uso ou créditos, ou comprometer a integridade
          e segurança do serviço.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.creditsBilling">
        <p>
          Recursos de IA consomem créditos. Pagamentos são processados pelo
          Stripe. Salvo disposição legal em contrário, valores pagos não são
          reembolsáveis. Alterações de preço serão comunicadas previamente.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.userContent">
        <p>
          Você mantém a titularidade do conteúdo que envia. Você nos concede
          licença limitada para processar e armazenar esse conteúdo apenas para
          operar o serviço. A propriedade intelectual do Tessel permanece
          conosco.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.disclaimers">
        <p>
          O serviço é fornecido "no estado em que se encontra". Saídas de IA
          podem conter erros e não substituem julgamento humano. Na máxima
          extensão permitida por lei, nossa responsabilidade é limitada.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.suspension">
        <p>
          Podemos suspender ou encerrar contas que violem estes termos. Você
          pode encerrar sua conta a qualquer momento; a exclusão de dados segue
          a Política de Privacidade.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.termsChanges">
        <p>
          Estes termos podem ser atualizados. Mudanças materiais serão
          comunicadas, e o uso continuado após a vigência implica aceitação.
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.governingLaw">
        <p>
          Estes termos são regidos pelas leis do Brasil, eleito o foro
          competente conforme a legislação aplicável.{" "}
          <strong>
            [detalhes a definir — placeholder de revisão jurídica]
          </strong>
          .
        </p>
      </LegalSection>

      <LegalSection headingKey="legal.terms.sections.contact">
        <p>
          Dúvidas sobre estes termos:{" "}
          <strong>[a definir — placeholder de revisão jurídica]</strong>.
        </p>
      </LegalSection>
    </LegalLayout>
  )
}
